import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-municipality-fees-summary-table',
    templateUrl: './municipality-fees-summary-table.component.html',
    styleUrls: ['./municipality-fees-summary-table.component.scss']
})
export class MunicipalityFeesSummaryTableComponent {
    @Input() rows;
    @Input() isEditMode: boolean = false;
    @Input() columns;
    @Input() isSupplier: boolean;
    mediaUrl = environment.apiUrl;

    constructor() { }
}
